exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vux-popup-radio-popup{background-color:#fff}", ""]);

// exports
